export default __webpack_public_path__ + "static/media/goodDay-fireworks.691ebe49.gif";